<template>
  <div
    class="modal fade"
    :id="id"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
    :key="modalKey ? modalKey : id"
  >
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div style="width: 100%">
            <h5 class="modal-title title">{{ title }}</h5>
            <slot name="title"></slot>
          </div>
          <div class="right-content">
            <img
              v-if="withMenuDots"
              @click="showContentFromDots"
              src="../icons/dod/menu_dots.svg"
              alt=""
            />
            <div v-if="contentFromDotsVisible" class="customTooltip">
              <slot name="menuContent"></slot>
            </div>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              :id="`${id}-close`"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <div class="modal-body">
          <slot name="content"></slot>
        </div>

        <div class="modal-footer" v-if="!hideDefaultFooter">
          <button
            type="button"
            class="btn btn-outline-dark"
            data-dismiss="modal"
          >
            Zamknij
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contentFromDotsVisible: false,
    };
  },
  // hideDefaultFooter - dla okien, które mają własny komplet przycisków w treści (np. potwierdzenie
  // Tak/Nie), gdzie stopkowe "Zamknij" byłoby trzecim, mylącym wyjściem.
  props: ["title", "id", "withMenuDots", "modalKey", "hideDefaultFooter"],
  methods: {
    showContentFromDots() {
      this.contentFromDotsVisible = !this.contentFromDotsVisible;
    },
  },
};
</script>

<style scoped>
.title {
  font-weight: 600;
}
.modal-header {
  display: flex;
  align-items: center;
}
.modal-header .close {
  font-size: 40px;
  font-weight: 200;
}
.modal-header h5 {
  font-size: 18px;
}
.right-content {
  display: flex;
  align-content: center;
  gap: 1rem;
  position: relative;
}
.right-content img {
  cursor: pointer;
}

.customTooltip {
  position: absolute;
  z-index: 999;
  background: #fff;
  top: 25px;
  right: -40px;
  transform: translateX(-50%);
  display: flex;
  height: 35px;
  padding: 8.326px 23.721px 8.674px 19.279px;
  align-items: center;
  color: #090741;
  font-family: Poppins;
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
  cursor: pointer;
  gap: 1rem;
  align-items: center;
  width: 180px;
  border-radius: 2px;
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.25);
}
</style>
